import { z } from 'zod';
import { isoDateTimeSchema } from '../../common.js';
/**
 * REST contract for the outbound calendar feed's token lifecycle
 * (`POST/GET/DELETE /api/calendar/feed-token`, WS-22). The token itself is only ever
 * returned once, straight out of mint — `GET` (status) never echoes it back, matching the
 * session-token-hashing posture: a leaked status response reveals nothing replayable.
 */
export const feedTokenStatusResponseSchema = z.object({
    exists: z.boolean(),
    createdAt: isoDateTimeSchema.nullable(),
    lastFetchedAt: isoDateTimeSchema.nullable(),
});
export const mintFeedTokenResponseSchema = z.object({
    token: z.string().min(1),
});
/** Path suffix Google/iOS fetch: `/api/calendar/feed/<token>.ics`. */
export const CALENDAR_FEED_ICS_EXTENSION = '.ics';
//# sourceMappingURL=schema.js.map